module.exports = __webpack_public_path__ + "static/media/office_full.05693efa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/office_full.jpg
// module id = 99
// module chunks = 0